import React from "react";

function article_1() {
	return {
		
	};
}

function article_2() {
	return {
	
	};
}

const myArticles = [article_1, article_2];

export default myArticles;
